/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hip (cm)`)
};

const es_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadera (cm)`)
};

const de_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüfte (cm)`)
};

const nl_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heup (cm)`)
};

const fr_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanches (cm)`)
};

const it_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fianchi (cm)`)
};

const pt_br2_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadril (cm)`)
};

const pt_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca (cm)`)
};

const ja_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒップ (cm)`)
};

const zh_bf_hip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`臀围（厘米）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_hip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_hip(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_hip", locale)
	if (locale === "en") return en_bf_hip(inputs)
	if (locale === "es") return es_bf_hip(inputs)
	if (locale === "de") return de_bf_hip(inputs)
	if (locale === "nl") return nl_bf_hip(inputs)
	if (locale === "fr") return fr_bf_hip(inputs)
	if (locale === "it") return it_bf_hip(inputs)
	if (locale === "pt-BR") return pt_br2_bf_hip(inputs)
	if (locale === "pt") return pt_bf_hip(inputs)
	if (locale === "ja") return ja_bf_hip(inputs)
	return zh_bf_hip(inputs)
};